export default "__VITE_ASSET__2a940c25__"